import { render, staticRenderFns } from "./HeaderEndorsementList.vue?vue&type=template&id=71b6c83e"
import script from "./HeaderEndorsementList.vue?vue&type=script&lang=js"
export * from "./HeaderEndorsementList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports